import { render, staticRenderFns } from "./service1.vue?vue&type=template&id=269313de&"
import script from "./service1.vue?vue&type=script&lang=js&"
export * from "./service1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('269313de')) {
      api.createRecord('269313de', component.options)
    } else {
      api.reload('269313de', component.options)
    }
    module.hot.accept("./service1.vue?vue&type=template&id=269313de&", function () {
      api.rerender('269313de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_home/service1.vue"
export default component.exports